var dialogIDCounter = 1;
var buttonsList = {};

var AbstractDialog = function () {

    var options = {};
    var ID = dialogIDCounter;
    var self = this;

    this.getId = function () {
        return ID;
    };

    this.getOptions = function () {
        return options;
    };

    this.inArray = function (button) {
        var founded = false;
        if (isDefined(button)) {
            $.each(buttonsList, function (i, v) {
                if (isDefined(v)) {
                    if (v.is(button)) {
                        founded = true;
                    }
                }
            });
        }
        return founded;
    };

    this.setDefaultOptions = function () {

        options = {
            buttonPointer: undefined,
            event: "",
            close: true,
            bar: {
                title: "",
                options: "",
                help: false
            },
            defaults: {
                centered: true,
                dialog: true,
                draggable: true
            },
            normal: {
                centered: true,
                dialog: true,
                draggable: true
            },
            mobile: {
                centered: true,
                dialog: true,
                draggable: false
            },
            insertIntoParent: true,
            content: " ",
            maxWidth: 0,
            maxHeight: 0,
            beforeClose: function (callback) {
                callback(true)
            },
            afterClose: function (callback) {
                callback(true)
            },
            changesDetect: false,
            changeFound: false,
            classes: {
                container: "",
                bar: "",
                title: "",
                close: "",
                body: "",
                content: ""
            }
        };
    };

    function position(container, event, callback) {

        var parent;
        var parentWidth;

        var dialogWidth = container.outerWidth(true);

        var newPosY = container.position.top;
        var newPosX = container.position.left;

        if ((container.attr("data-parent-window") !== '' && options.insertIntoParent) && !options.defaults.dialog) {

            parent = getParentDialog(container);

            if (options.defaults.centered) {
                container.centerIntoParent(parent);
            } else {

                newPosY = event.pageY;
                newPosX = event.pageX;

                var headAndOptions = parent.find(".edit-body").first().find(">.options-bar");
                var toDecrease = 0;

                headAndOptions.each(function () {
                    toDecrease += $(this).outerHeight(true);
                });

                var shiftScroll;
                if (isDefined(container.data("firstScrollTop"))) {
                    shiftScroll = $(window).scrollTop() - container.data("firstScrollTop");
                } else {
                    container.data("firstScrollTop", $(window).scrollTop());
                    shiftScroll = 0;
                }

                var parentTop = parent.offset().top;
                var parentLeft = parent.offset().left;
                parentWidth = parent.width();
                var parentScrollTop = parent.find(".edit-content").first().scrollTop();

                newPosY = newPosY - parentTop + parentScrollTop - toDecrease + shiftScroll;
                newPosX = newPosX - parentLeft;

                if (newPosX + dialogWidth > parentWidth) {
                    newPosX = newPosX - (newPosX + dialogWidth - parentWidth) - 50;
                }

                container.css({left: newPosX, top: newPosY});

            }

        } else {

            if (options.defaults.centered) {
                container.centerToScreen();
            } else {

                if (isDefined(event)) {
                    newPosY = event.pageY;
                    newPosX = event.pageX;
                }

                parent = $(window);
                parentWidth = parent.width();

                if ((newPosX + dialogWidth) > parentWidth) {
                    newPosX = parentWidth - (dialogWidth + 50);
                }

                container.css({left: newPosX, top: newPosY});

            }

        }

        callback();
    }

    this.positionDialog = function (container, event, callback) {

        if (screen.width < 700) {
            options.defaults.centered = true;
        }

        if (self.moveToBody(container).find("img").length > 0) {

            var IMG = self.moveToBody(container).find("img");

            IMG.batchImageLoad({
                loadingCompleteCallback: function () {

                    position(container, event, function () {
                        callback();
                    });

                }
            });

        } else {
            position(container, event, function () {
                callback();
            });
        }
    };

    this.getViewPortWidth = function (dialog, orientation) {

        var viewPortWidth;

        if ((dialog.attr("data-parent-window") && options.insertIntoParent) && !options.defaults.dialog) {
            viewPortWidth = self.getParentDialog(self.moveToContainer(dialog)).width();
        } else {
            if (isDefined(orientation)) {
                if (orientation === 90 || orientation === -90) {
                    viewPortWidth = $(window).width();
                } else {
                    viewPortWidth = $(window).height();
                }
            } else {
                viewPortWidth = $(window).width();
            }
        }

        return viewPortWidth;

    };

    this.setWidth = function (dialog, width, orientation) {

        // TODO: Rozšiřovat dialog co to jde, když je uvnitř flexbox nebo grid

        var viewPortWidth = this.getViewPortWidth(dialog, orientation);

        var maxWidth;
        var percent = 80;

        if (!isDefined(orientation) && viewPortWidth > 700) {

            maxWidth = ((viewPortWidth * percent) / 100);

            if (isDefined(width)) {

                if (width === "full") {
                    width = viewPortWidth;
                } else if ((width === "auto") || width === 0) {
                    width = "auto";
                } else {

                    if (!/[0-9]*%/.test(width)) {

                        width = parseInt(width);

                        if (width > maxWidth) {
                            width = maxWidth;
                        }

                    }
                }

            } else {
                width = "auto";
            }

            if (maxWidth > 1900) {
                maxWidth = 1900;
            }

        } else {
            maxWidth = viewPortWidth;
            width = viewPortWidth;
        }

        if (options.maxWidth < maxWidth && options.maxWidth > 0) {
            maxWidth = options.maxWidth;
        }

        dialog.css({"width": width + "px", "max-width": maxWidth + "px"});
    };

    this.setHeight = function (dialog, height, orientation) {

        var dialogHeight = getContainerHeight(dialog);
        var maxHeight;
        var viewPortHeight;

        if ((dialog.attr("data-parent-window") && options.insertIntoParent) && !options.defaults.dialog) {
            viewPortHeight = getContainerHeight(self.moveToBody(self.getParentDialog(dialog)));
        } else {
            viewPortHeight = $(window).height();
        }

        var viewPortWidth = this.getViewPortWidth(dialog, orientation);

        if (viewPortWidth > 700) {

            maxHeight = ((viewPortHeight * 90) / 100);

            if (isDefined(height)) {

                if (height === "full") {
                    height = (viewPortHeight * 90) / 100;
                } else if (height === "auto" || height === 0) {
                    height = "auto";
                } else {

                    if (!/[0-9]*%/.test(height)) {

                        height = parseInt(height);

                        if (height > maxHeight) {
                            height = maxHeight;
                        }

                    }
                }

            } else {
                height = "auto";
            }
        } else {
            maxHeight = viewPortHeight;
            height = maxHeight;
        }

        if (options.maxHeight < maxHeight && options.maxHeight > 0) {
            maxHeight = options.maxHeight;
        }

        self.moveToBody(dialog).parent().find(">.options-bar").each(function () {
            maxHeight -= $(this).outerHeight(true);
        });

        self.moveToBody(dialog).css({"height": height + "px", "max-height": maxHeight + "px"});
    };

    this.refreshCoverLayer = function (parent, id, orientation) {

        if (options.defaults.dialog) {

            var docW;
            var docH;

            if (isDefined(parent)) {
                parent = $("#" + parent + "");
            }

            if ((isDefined(parent) && options.insertIntoParent) && !options.defaults.dialog) {

                if (isDefined(orientation) && (orientation === 90 || orientation === -90)) {
                    docW = getContainerHeight(self.moveToBody(parent).parent());
                    docH = self.moveToBody(parent).outerWidth();
                } else {
                    docW = self.moveToBody(parent).outerWidth();
                    docH = getContainerHeight(self.moveToBody(parent).parent());
                }

            } else {

                if (isDefined(orientation) && (orientation === 90 || orientation === -90)) {
                    docW = screen.width;
                    docH = screen.height;
                } else {
                    docW = $(window).width();
                    docH = getDocHeight();
                }
            }

            $(document).find("#dialog-background" + id + "").css({
                "width": "" + docW + "px",
                "height": "" + docH + "px"
            });

        }

    };

    function getParentDialog(target) {
        target = self.moveToContainer(target);

        if (target.closest(".dialog").length > 0) {
            return target.parent().closest(".dialog");
        } else {
            return false;
        }
    }

    this.getParentDialog = function (target) {
        return getParentDialog(target);
    };

    this.moveToContainer = function (target) {

        if (isObject(target)) {
            if (target.hasClass("dialog")) {
                return target;
            } else {
                if (target.closest(".dialog").length > 0) {
                    return target.closest(".dialog");
                } else {
                    return false;
                }
            }
        }
        return false;
    };

    this.getDialogElemId = function (button) {
        var target = self.moveToContainer(button);
        return target.attr("id");
    };

    this.getDialogElemNumId = function (button) {

        var id = self.getDialogElemId(button).split("-");
        id = parseInt(id[1]);
        return id;
    };

    this.moveToBody = function (from) {
        var target = self.moveToContainer(from);
        target = target.find(".edit-content").first();
        return target;
    };

    this.refresh = function (dialog, orientation, callback) {

        if (!this.isDialog(dialog)) {
            dialog = self.moveToContainer(dialog);
        }

        var id = parseInt(self.getDialogElemNumId(dialog));
        var event;

        if (options.defaults.centered) {
            event = undefined;
        } else {
            event = options.event;
        }

        var width, height;

        if (isDefined(dialog.data("maxWidth"))) {
            width = dialog.data("maxWidth");
        }
        if (isDefined(dialog.data("maxHeight"))) {
            height = dialog.data("maxHeight");
        }

        var editor_body = self.moveToBody(dialog);

        self.setWidth(dialog, width, orientation);
        self.setHeight(dialog, height, orientation);

        self.positionDialog(dialog, event, function () {

            if (dialog.attr("data-parent-window")) {
                self.refreshCoverLayer(dialog.attr("data-parent-window"), id, orientation);
            } else {
                self.refreshCoverLayer(undefined, id, orientation);
            }

            if (isFunction(callback)) {
                callback();
            }

        });

    };

    this.changeDetect = function () {
        options.changeFound = true;
    };

    this.changesDetectEnabled = function () {
        return options.changesDetect;
    };

    this.changesDetected = function () {
        return options.changeFound;
    };

    this.customizeMobile = function () {
        if ($(window).width() < 700) {
            options.defaults.draggable = options.mobile.draggable;
            options.defaults.dialog = options.mobile.dialog;
            options.defaults.centered = options.mobile.centered;
        } else {
            options.defaults.draggable = options.normal.draggable;
            options.defaults.dialog = options.normal.dialog;
            options.defaults.centered = options.normal.centered;
        }
    };

    this.getHelp = function () {
        return options.help;
    };

    this.update = function (dialog, content) {
        var body = self.moveToBody(dialog);
        body.html(content);
    };

    this.getButtonPointer = function () {
        return (buttonsList[ID]);
    };

    this.remove = function (button, effect, callback) {

        var container = self.moveToContainer(button);

        if (container !== false) {

            options.beforeClose(function (result) {

                if (result) {

                    var containerID = self.getDialogElemId(container);

                    if (isFunction(options.close)) {
                        options.close(container);
                    } else {

                        if (container.find("#resize-senzor" + containerID + "").length > 0) {
                            ResizeSensor.detach(container.find("#resize-Senzor" + containerID + ""));
                        }

                        container.find(".dialog").each(function () {
                            var instance = $(this).data("instance");
                            instance.remove($(this));
                        });

                        var dialog = options.defaults.dialog;

                        if (dialog) {
                            if (container.closest(".dialog-cover-layer").length) {
                                container.closest(".dialog-cover-layer").remove();
                            } else {
                                container.remove();
                            }
                        } else {

                            if (isFunction(effect)) {
                                options.effect(container);
                            } else {
                                container.remove();
                            }

                        }

                        delete buttonsList[ID];

                        options.afterClose(function (result) {

                            if (isFunction(callback)) {
                                if (result) {
                                    callback(result);
                                }
                            }

                        });
                    }
                }
            });

        }
    };

    this.isDialog = function (el) {

        if (isObject(el)) {
            if (el.attr("class") === "dialog") {
                return true;
            }
        }
        return false;
    };

    this.buildDialog = function (definedOptions, callback) {

        var parentDialogID = "";

        var dialogId = ID;
        var dialogIdFull = "Dialog-" + dialogId;

        dialogIDCounter++;

        self.setDefaultOptions(); // set defaults
        parseOptions(options, definedOptions);

        if (isObject(options.buttonPointer)) {
            if (self.inArray(options.buttonPointer)) {
                console.log("Dialog is still opened by self button!");
                return;
            }
            buttonsList[dialogId] = options.buttonPointer;
            var parentWindow = self.moveToContainer(options.buttonPointer);
            if (parentWindow !== false) {
                parentDialogID = parentWindow.attr("id");
                if (!options.dialog) {
                    options.insertIntoParent = true;
                }
            }
        }

        var dialogCloseButton = "";

        if (options.close) {
            dialogCloseButton = '<div class="navbar-group"><div class="navbar-item icon-link"><a class="option close close-dialog"><i class="fa fa-times fa-editor"></i></a></div></div>';
        }

        var dialogOptionsBar = '';

        if (isObject(options.bar)) {

            if (options.bar.title === "") {
                options.bar.title = dialogIdFull;
            }

            dialogOptionsBar = '<div class="navbar options-bar header">' +
                '<div class="navbar-title ' + options.classes.bar + '">' + options.bar.title + '</div>' +
                dialogCloseButton +
                '</div>';
        }

        self.customizeMobile();

        var data = '' +
            '' + (options.defaults.dialog ? '<div class="dialog-cover-layer" id="dialog-background' + dialogId + '">' : '') + '' +
            '<div class="dialog ' + options.classes.container + '" id="' + dialogIdFull + '" data-parent-window="' + parentDialogID + '">' +
            '<div class="resize-senzor" id="resize-senzor' + dialogId + '"><div class="editor">' +
            dialogOptionsBar +
            '<div class="edit-content ' + options.classes.content + '">' +
            options.content +
            '</div>' +
            '</div>' +
            '</div></div>' +
            (options.defaults.dialog ? '</div>' : '');

        if (parentDialogID !== "" && options.insertIntoParent && !options.defaults.dialog) {
            self.moveToBody($("#" + parentDialogID + "")).append(data);
            self.refreshCoverLayer(parentDialogID, dialogId);
        } else {
            $("body").append(data);
            self.refreshCoverLayer(undefined, dialogId);
        }

        var container = $(document).find('#' + dialogIdFull + '');

        if (isDefined(options.maxWidth) && options.maxWidth !== "") {
            container.data("maxWidth", options.maxWidth);
        }
        if (isDefined(options.maxHeight) && options.maxHeight !== "") {
            container.data("maxHeight", options.maxHeight);
        }

        self.refresh(container, undefined, function () {

            if (isFunction(options.effect)) {
                options.effect(container);
            } else {
                container.css({display: "inline-block"});
            }

            callback(container);

        });
    };

};


var BasicDialog = function (definedOptions, callback) {

    AbstractDialog.call(this);
    var self = this;

    var build = function (callback) {

        self.buildDialog(definedOptions, function (dialog) {

            var options = self.getOptions();

            self.moveToBody(dialog).parent().on("scroll", function () {
                $(self).find(".dialog").each(function () {
                    self.refresh($(self));
                });
            });

            if (!options.defaults.dialog && options.defaults.draggable) {

                var disable = [];

                if (options.close) {
                    disable.push(dialog.find(".close-dialog"));
                }

                disable.push(dialog.find(".edit-content"));

                if (isDefined(options.bar.options)) {
                    disable.push(dialog.find(".options-bar .option"));
                }

                dialog.drags("", disable);
            }

            new ResizeSensor($("#resize-senzor" + self.getId() + ""), function (el) {
                if (isDefined(el)) {
                    var ins = $.dialog.getInstance(el);
                    var cont = $.dialog.moveToContainer(el);
                    ins.refresh(cont, undefined);
                }
            });

            if (self.changesDetectEnabled()) {

                /* Input fields changes detector */
                dialog.on("change", "input,select", function (e) {
                    var el = $(this);
                    var instance = $.dialog.getInstance(el);
                    if (isDefined(instance)) {
                        if (instance.changesDetectEnabled()) {
                            instance.changeDetect();
                        }
                    }
                });

                dialog.on("keyup", "textarea", function (e) {
                    var el = $(this);
                    var instance = $.dialog.getInstance(el);
                    if (isDefined(instance)) {
                        if (instance.changesDetectEnabled()) {
                            instance.changeDetect();
                        }
                    }
                });
            }

            var instance = self;
            dialog.data("instance", instance);

            callback(dialog, instance);

        });

    };

    build(function (dialog, instance) {
        if (isFunction(callback)) {
            callback(dialog, instance);
        }
    });
};


var AlertDialog = function (dialogSettings, callback) {

    AbstractDialog.apply(this);

    var self = this;
    var message = dialogSettings.message;

    var settings = $.extend({}, dialogSettings);
    delete  settings.message;

    if (!isDefined(settings.bar)) {
        settings.bar = {
            title: 'Hlášení programu'
        };
    }

    if (!isDefined(settings.normal)) {
        settings.normal = {
            centered: true,
            dialog: true
        }
    }

    settings.content = '<br /><div>' + message + '</div><br />';

    self.buildDialog(settings, function (dialog) {

        var instance = self;
        dialog.data("instance", instance);

        if (isFunction(callback)) {
            callback(dialog, instance);
        }

    });

};

var ConfirmDialog = function (dialogSettings, callback) {

    AbstractDialog.apply(this);
    var self = this;

    var ask = dialogSettings.ask;
    var additional = dialogSettings.additionalContent ? dialogSettings.additionalContent : "";

    var settings = $.extend({}, dialogSettings);

    delete settings.ask;
    delete settings.additionalContent;

    if (!isDefined(settings.bar)) {
        settings.bar = {
            title: 'Hlášení programu'
        };
    }

    if (!isDefined(settings.normal)) {
        settings.normal = {
            centered: true,
            dialog: true
        }
    }

    settings.close = false;
    settings.content = '<div>' + ask + '<br />' + additional + '<br />' +
        '<div class="fields-wrap ">' +
        '<a class="no btn btn-default btn-sm" id="mainWindowNo"><i class="fas fa-times text-danger"></i> Ne</a>' +
        '<a class="yes btn btn-default btn-sm" id="mainWindowYes"><i class="fas fa-check text-success"></i> Ano</a></div>' +
        '</div>';

    var build = function (callback) {

        self.buildDialog(settings, function (dialog) {

            var formData;

            dialog.data("instance", self);

            if (isDefined(settings.buttonPointer)) {

                if (settings.buttonPointer.prop("tagName") === "INPUT" || settings.buttonPointer.prop("tagName") === "BUTTON") {

                    var form = $(settings.buttonPointer).closest("form");

                    form.submit(function (e) {
                        formData = new FormData(this);
                        e.preventDefault();
                        settings.event.preventDefault();
                    });

                } else {
                    settings.event.preventDefault();
                }

            }

            if (dialog !== false) {

                if (isDefined(settings.event.target)) {

                    if (isDefined(settings.event) && (settings.event.target.nodeName === "INPUT" || settings.event.target.nodeName === "BUTTON")) {

                        $("#" + dialog.attr("id") + " #mainWindowYes").click(function (e) {
                            e.preventDefault();

                            if (e.handled !== true) {
                                self.remove($(this));
                                e.handled = true;
                                callback(formData);
                            }

                        });

                        $("#" + dialog.attr("id") + " #mainWindowNo").click(function (e) {
                            e.preventDefault();

                            if (e.handled !== true) {
                                self.remove($(this));
                                e.handled = true;
                                callback(false);
                            }

                        });

                    } else {

                        $("#" + dialog.attr("id") + " #mainWindowYes").click(function (e) {
                            e.preventDefault();

                            if (e.handled !== true) {
                                self.remove($(this));
                                e.handled = true;
                                callback(true);
                            }

                        });

                        $("#" + dialog.attr("id") + " #mainWindowNo").click(function (e) {
                            e.preventDefault();

                            if (e.handled !== true) {
                                self.remove($(this));
                                e.handled = true;
                                callback(false);
                            }

                        });

                    }

                } else {

                    $("#" + dialog.attr("id") + " #mainWindowYes").click(function (e) {
                        e.preventDefault();

                        if (e.handled !== true) {
                            self.remove($(this));
                            e.handled = true;
                            callback(true);
                        }

                    });

                    $("#" + dialog.attr("id") + " #mainWindowNo").click(function (e) {
                        e.preventDefault();

                        if (e.handled !== true) {
                            self.remove($(this));
                            e.handled = true;
                            callback(false);
                        }

                    });

                }
            }

        });

    };

    build(function (result) {
        if (isFunction(callback)) {
            callback(result);
        }
    });
};

$(document).ready(function () {

    $(document).on("click", ".dialog .close-dialog, .dialog .close-dialog-handler", function (e) {

        var btn = $(this);

        var dialog = $.dialog.moveToContainer(btn);
        var instance = $.dialog.getInstance(dialog);

        if (instance.changesDetectEnabled()) {
            if (instance.changesDetected()) {
                new ConfirmDialog(btn, "Byly detekovány změny polí, opravdu chcete zavřít okno?", e, function (result) {
                    if (result) {
                        instance.remove(btn);
                    }
                });
            } else {
                instance.remove(btn);
            }
        } else {
            instance.remove(btn);
        }

    });

    $(window).on("orientationchange", function (event) {

        var orientation = this.orientation;

        $(document).find(".dialog").each(function () {
            var instance = $.dialog.getInstance($(this));
            instance.refresh($(this), orientation);
        });

    });

    $(window).on('resize', function () {

        var orientation = this.orientation;

        $(document).find(".dialog").each(function () {
            var instance = $.dialog.getInstance($(this));
            instance.refresh($(this), orientation);
            instance.customizeMobile();
        });

    });

    $(window).on("scroll", function () {

        var orientation = this.orientation;

        $(document).find(".dialog").each(function () {
            var instance = $.dialog.getInstance($(this));
            instance.refresh($(this), orientation);
        });

    });

});


(function (window, $) {

    if (typeof $ !== 'function') {
        return console.error('$.dialog: jQuery is missing, load it please');
    }

    $.dialog = {

        moveToContainer: function (btn) {
            return btn.closest(".dialog");
        },

        getInstance: function (dialog) {
            if (!dialog.hasClass("dialog")) {
                dialog = this.moveToContainer(dialog);
            }
            return dialog.data("instance");
        },

        moveToBody: function (dialog) {
            var instance = this.getInstance(dialog);
            if (isDefined(instance)) {
                return instance.moveToBody(dialog);
            }
            return false;
        }

    };

})(window, window.jQuery);
